module.exports = __webpack_public_path__ + "img/hair_front_female_frizzy_middle_part_mask.8839648a.png";